var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76247 3.10734C7.35242 2.69729 6.6876 2.69729 6.27755 3.10734C6.20478 3.18011 6.14493 3.26089 6.09799 3.34685L1.70793 7.73692C1.29788 8.14697 1.29788 8.81179 1.70793 9.22184C2.11798 9.63189 2.7828 9.63189 3.19285 9.22184L7.04999 5.36471L10.7323 9.04704C11.1424 9.45709 11.8072 9.45709 12.2172 9.04704C12.6273 8.63699 12.6273 7.97216 12.2172 7.56211L7.76247 3.10734Z",
    fill: "#202029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.f690ba34638782b7b000bb8f4d91d683.svg";
export { ForwardRef as ReactComponent };